<template>
  <van-popup :show="show" position="bottom" :style="{ height: '100vh', width: '100%' }"
    :overlay-style="{ background: 'rgba(0, 0, 0, 0.45)' }" class="share-action-popup"
    @update:show="emit('update:show', $event)" @close="emit('close')">
    <div class="share-panel">
      <div class="panel-header">
        <van-icon name="cross" size="20" class="close-icon" @click="emit('close')" />
      </div>
      <div class="preview-slot">
        <slot name="preview" />
      </div>
      <div class="action-list">
        <button v-for="item in shareOptions" :key="item.key" type="button" class="action-item"
          :class="`action-${item.key}`" @click="handleSelect(item)">
          <span class="action-icon-wrap">
            <SvgIcon width="50px" height="50px" :name="item.icon" />
          </span>
          <span>{{ item.name }}</span>
        </button>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits([
  'update:show',
  'share-whatsapp',
  'share-telegram',
  'save-image',
  'copy-link',
  'close',
])

const shareOptions = [
  { name: 'WhatsApp', icon: 'whatsapp', key: 'whatsapp' },
  { name: 'Telegram', icon: 'tel', key: 'telegram' },
  { name: 'Save Image', icon: 'save', key: 'save' },
  { name: 'Copy Link', icon: 'copy', key: 'copy' },
]

const handleSelect = (option) => {
  const key = option?.key
  if (key === 'whatsapp') emit('share-whatsapp')
  if (key === 'telegram') emit('share-telegram')
  if (key === 'save') emit('save-image')
  if (key === 'copy') emit('copy-link')
}
</script>

<style scoped lang="less">
.share-action-popup {
  background: rgba(0, 0, 0, 0.35);

  .share-panel {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    height: 100%;
    padding: 10px 12px calc(14px + env(safe-area-inset-bottom));
  }

  .panel-header {
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2px;
    margin-bottom: 10px;

    .close-icon {
      color: #ffffff;
      width: 24px;
    }

    .panel-title {
      font-size: 17px;
      line-height: 24px;
      font-weight: 700;
      color: #202b3c;
    }

    .placeholder {
      width: 24px;
    }
  }

  .preview-slot {
    display: flex;
    justify-content: center;
    padding: 4px 0 12px;
    height: calc(100vh - 170px);
    overflow-y: auto;
  }

  .action-list {
    background: transparent;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2px;
    background: #ffffff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .action-item {
    border: none;
    background: transparent;
    padding: 10px 4px 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #202b3c;
    font-size: 21px;

    .action-icon-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }

    span:last-child {
      font-size: 12px;
      line-height: 16px;
      color: #344054;
      font-weight: 500;
    }
  }
}
</style>
